export class Speed {

    calculateCurrentSpeedMbps(downloadList: number[], timeList: number[], numberOfSlices: number): number {
        if (downloadList.length > 1 && timeList.length > 1) {
            const startTime: number = timeList[0];
            const lastCount: number = Math.min(downloadList.length, timeList.length) - 1;
            const endTime: number = timeList[lastCount];

            const timeRunDifference: number = endTime - startTime;

            const timeIntervalSlice: number = timeRunDifference / numberOfSlices;

            let speedSlices: number[] = [];

            let lastSliceTransferredBytes: number = downloadList[0];
            let lastPosition = 1;

            for (let i = 0; i < numberOfSlices; ++i) {
                let currentTime: number = timeList[lastPosition];
                const endTimeSlice: number = i * timeIntervalSlice + startTime;
                while ((currentTime < endTimeSlice) && (lastPosition < lastCount)) {
                    lastPosition = lastPosition + 1;
                    currentTime = timeList[lastPosition];
                }
                if (lastPosition < lastCount) {
                    const timeOutOfSlice: number = currentTime - endTimeSlice;
                    const percentOutOfSlice: number = timeOutOfSlice / (currentTime - timeList[lastPosition - 1]);
                    const transferredBytesAtEndOfSlice: number = downloadList[lastPosition] - ((downloadList[lastPosition] - downloadList[lastPosition - 1]) * percentOutOfSlice);
                    const speed: number = (transferredBytesAtEndOfSlice - lastSliceTransferredBytes) / timeIntervalSlice;
                    speedSlices.push(speed);
                    lastSliceTransferredBytes = transferredBytesAtEndOfSlice;
                } else {
                    speedSlices.push(0);
                }
            }
            speedSlices = speedSlices.sort();

            const maximumRegionStart: number = (speedSlices.length * 30 / 100) - 1;
            const maximumRegionEnd: number = (speedSlices.length * 90 / 100) - 1;

            if (maximumRegionStart + 1 < maximumRegionEnd) {
                speedSlices = speedSlices.slice(maximumRegionStart, maximumRegionEnd + 1);
            }

            let speedSum = 0;
            for (let i = 0; i < speedSlices.length; ++i) {
                speedSum = speedSum + speedSlices[i];
            }

            return parseFloat(((speedSum / speedSlices.length) * 8 / 1000).toFixed(2));  // 1000 / 1000 because the calculate in ms instead of s
        }
    }

}
